// extracted by mini-css-extract-plugin
export default {"p":"b024b91f24 _7e6c4242b9 _1af2f2b90f","clr":"d1fbacbfa4","dls":"_30bd97ede0"};